<template>
  <div>
    <page-title
      heading="Edit Data Klinik"
      :breadcrumb="[
        {
          label: 'Daftar Klinik',
          link: '/klinik'
        },
        {
          label: 'Edit Klinik',
          active: true
        }
      ]"
    />

    <div class="container-fluid">
      <div class="card card-box">
        <div class="card-body">
          <b-row>
            <b-col sm="3">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">Nama Klinik</label>
                <label style="color:red"> *</label>
                <b-form-input
                  v-model="formData.nama_klinik"
                  type="text"
                  required
                  ref="nama_klinik"
                />
                <template
                  v-if="
                    formData.nama_klinik == '' || formData.nama_klinik == null
                  "
                >
                  <label style="color: red">Kolom harus diisi</label>
                </template>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">No. Izin Klinik</label>
                <label style="color:red"> *</label>
                <b-form-input
                  v-model="formData.nomor_ijin"
                  type="text"
                  required
                  ref="nomor_ijin"
                  @input="cekValue($event)"
                />
                <template
                  v-if="
                    formData.nomor_ijin == '' || formData.nomor_ijin == null
                  "
                >
                  <label style="color: red">Kolom harus diisi</label>
                </template>
                <template v-else-if="!validasiNoIzin && !loadEdit">
                  <label style="color: red"
                    >Nomor izin klinik sudah digunakan</label
                  >
                </template>
                <template v-else-if="validasiNoIzin && !loadEdit">
                  <label style="color: #1bc943"
                    >Nomor izin klinik dapat digunakan</label
                  >
                </template>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">Jenis Klinik</label>
                <label style="color:red"> *</label>
                <vue-select
                  :options="faskes"
                  v-model="selectedFaskes"
                  placeholder="Pilih Jenis Klinik"
                />
                <template v-if="selectedFaskes == '' || selectedFaskes == null">
                  <label style="color: red">Kolom harus dipilih</label>
                </template>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">Kabupaten/Kota</label>
                <label style="color:red"> *</label>
                <vue-select
                  :options="cities"
                  v-model="selectedKota"
                  placeholder="Pilih Kabupaten/Kota"
                />
                <template v-if="selectedKota == '' || selectedKota == null">
                  <label style="color: red">Kolom harus dipilih</label>
                </template>
              </b-form-group>
            </b-col>
            <b-col sm="6" class="offset-6 mt-5">
              <template>
                <b-button
                  class="ml-3 text-uppercase"
                  variant="primary"
                  style="font-size:17.5px;float:right;border-radius:0.65rem;"
                  @click="submitForm"
                >
                  simpan
                </b-button>
                <b-button
                  :to="{ name: 'klinik-list' }"
                  class="text-uppercase"
                  variant="danger"
                  style="font-size:17.5px;float:right;border-radius:0.65rem;"
                >
                  tutup
                </b-button>
              </template>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import startCase from "lodash/startCase";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    beingSubmit: false,
    klinik_id: null,
    formData: {
      no_klinik: null,
      nama_klinik: null,
      nomor_ijin: null,
      tipe_faskes: null,
      kota: null
    },
    cities: [],
    faskes: [],
    selectedFaskes: null,
    selectedKota: null,
    validasiNoIzin: true,
    noIzinBefore: null,
    loadEdit: true
  }),
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        text: `Anda yakin untuk keluar dari halaman ini?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  beforeRouteEnter(to, from, next) {
    const { params } = to;
    const { klinik_id } = params;
    if (!klinik_id) {
      next({
        name: "klinik-list"
      });
    } else {
      next();
    }
  },
  mounted() {
    this.klinik_id = this.$router.currentRoute.params.klinik_id;
    this.getKlinikData();
  },
  components: {
    "vue-select": () => import("@/components/VueSelectClearable.vue")
  },
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  methods: {
    submitForm() {
      let err = false;
      if (
        this.formData.nama_klinik == "" ||
        this.formData.nama_klinik == null
      ) {
        this.$refs.nama_klinik.focus();
        err = true;
      } else if (
        this.formData.nomor_ijin == "" ||
        this.formData.nomor_ijin == null ||
        !this.validasiNoIzin
      ) {
        this.$refs.nomor_ijin.focus();
        err = true;
      } else if (this.selectedFaskes == "" || this.selectedFaskes == null) {
        this.$refs.nama_klinik.focus();
        window.scrollTo({
          top: 260,
          behavior: "smooth"
        });
        this.$refs.nama_klinik.blur();
        err = true;
      } else if (this.selectedKota == "" || this.selectedKota == null) {
        this.$refs.nama_klinik.focus();
        window.scrollTo({
          top: 260,
          behavior: "smooth"
        });
        this.$refs.nama_klinik.blur();
        err = true;
      }

      if (err) {
        this.$swal({
          text: `Silakan cek kembali pengisian data Anda!`,
          type: "warning"
        });
      } else {
        this.beingSubmit = true;
        this.editPasien();
      }
    },
    async editPasien() {
      try {
        const res = await axios.put(
          `${this.url_api}/klinik/branch/${this.klinik_id}?klinik_id=${this.getKlinikId}`,
          {
            ...this.formData,
            tipe_faskes:
              typeof this.selectedFaskes === "object"
                ? this.selectedFaskes.id
                : this.formData.tipe_faskes,
            kota:
              typeof this.selectedKota === "object"
                ? this.selectedKota.id
                : this.formData.kota
          }
        );
        const { status } = res.data;
        if (status) {
          this.$swal({
            text: `Data klinik berhasil disimpan!`,
            type: "success"
          }).then(res => {
            this.beingSubmit = true;
            this.$router.push({
              name: "klinik-list"
            });
          });
        }
      } catch (err) {
        // console.log(err);
      }
    },
    async getKlinikData() {
      this.klinik_id = this.$router.currentRoute.params.klinik_id;
      try {
        const res = await axios.get(`${this.url_api}/klinik/${this.klinik_id}?klinik_id=${this.getKlinikId}`);
        const { status, data } = res.data;

        if (data == null) {
          this.$swal({
            text: `Data klinik tidak ada`,
            type: "warning"
          }).then(res => {
            this.beingSubmit = true;
            this.$router.push({
              name: "klinik-list"
            });
          });
        } else {
          this.formData = data;
          this.noIzinBefore = data.nomor_ijin;
          this.getCity();
          this.getFaskes();
        }
      } catch (err) {
        // console.log(err);
      }
    },
    async getCity() {
      try {
        const res = await axios.get(`${this.url_api}/getcity`);
        const { data } = res.data;

        this.cities = data.map(
          val => (
            this.formData.kota == val.id
              ? (this.selectedKota = val.nama)
              : null,
            {
              ...val,
              label: `${val.nama}`
            }
          )
        );
      } catch (error) {
        // console.error(error);
      }
    },
    async getFaskes() {
      try {
        const res = await axios.get(`${this.url_api}/klinik/faskes`);
        const { data } = res.data;

        this.faskes = data.map(
          val => (
            this.formData.tipe_faskes == val.id
              ? (this.selectedFaskes = val.name)
              : null,
            {
              ...val,
              label: `${val.name}`
            }
          )
        );
      } catch (error) {
        // console.error(error);
      }
    },
    cekValue: debounce(function(val) {
      this.loadEdit = false;
      axios
        .get(`${this.url_api}/klinik/no_izin/cek`, {
          params: {
            no_izin: val,
            klinik_id: this.klinik_id
          }
        })
        .then(res => {
          if (val.toLowerCase() == this.noIzinBefore.toLowerCase()) {
            this.validasiNoIzin = true;
          } else if (res.data.status) {
            this.validasiNoIzin = true;
          } else if (!res.data.status) {
            this.validasiNoIzin = false;
          }
        });
    }, 500)
  }
};
</script>

<style lang="scss">
.custom-dropzone {
  .dz-message {
    padding: 10rem 1rem;
  }
}
</style>
